import Vue from 'vue'
import Vuex from 'vuex'
import {isValidImage, getKuchaDiscussionMapping, getKuchaMapping, getDictionary, getCaveEntries} from '@/services/repository'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)


export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    breadcrumb:[
      {
        text: 'Home',
        disabled: false,
        href: '/',
      },
    ],
    authenticated: false,
    gameLoaded:0,
    imageValidDic: {},
    result: 0,
    results: {},
    loadedPDFs: {},
    iconography: {},
    bibKeywords: [],
    caveEntries: [],
    caveTypes: [],
    sites:[],
    styles:[],
    districts:[],
    regions:[],
    locations:[],
    wallLocation:[],
    mapping: {},
    discussionMapping: {},
    searchText:"",
    totalRes:0,
    searchPack:0,
    disableSearch:true,
    packageVersion: "© 2021 v 1.2.9",
    imgURL: "",
    URL: "",
    user: {},
    prevVisited: "",
    showMenu: false,
    statistics: {},
  },
  mutations: {
    replaceLastBreadcrumb(state, newValue) {
      if (state.breadcrumb.length > 0) {
        state.breadcrumb [state.breadcrumb.length - 1].text = newValue
      }
    },
    addToimageValidDic(state, payload){
      if (!state.imageValidDic) {
        Vue.set(state, "imageValidDic", {}); // Setze das gesamte Objekt reaktiv
      }
      if (!state.imageValidDic[payload.index]) {
        Vue.set(state.imageValidDic, payload.index, {});
      }
      Vue.set(state.imageValidDic[payload.index], "valid", payload.valid);

    },
    addThumbnail(state, payload){
      if (!state.imageValidDic) {
        Vue.set(state, "imageValidDic", {}); // Setze das gesamte Objekt reaktiv
      }
      if (!state.imageValidDic[payload.index]) {
        Vue.set(state.imageValidDic, payload.index, {});
      }
      Vue.set(state.imageValidDic[payload.index], "thumbnail", payload.thumbnail);
    },
    setStatistics(state, payload){
      state.statistics = payload
    },
    setBreadcrumb(state, payload){
      state.breadcrumb = payload
    },
    setLoadedPDFs(state, payload){
      state.loadedPDFs = payload
    },
    setGameLoaded(state, payload){
      state.gameLoaded = payload
    },
    setUser(state, payload){
      state.imageValidDic = {}
      state.user = payload
    },
    setWallLocation(state, payload){
      state.wallLocation = payload
    },
    setCaveTypes(state, payload){
      state.caveTypes = payload
    },
    setCaveEntries(state, payload){
      state.caveEntries = payload
    },
    setSites(state, payload){
      state.sites = payload
    },
    setStyles(state, payload){
      state.styles = payload
    },
    setRegions(state, payload){
      state.regions = payload
    },
    setDistricts(state, payload){
      state.districts = payload
    },
    setIconography(state, payload){
      state.iconography = payload
    },
    setBibKeywords(state, payload){
      state.bibKeywords = payload
    },
    setLocations(state, payload){
      state.locations = payload
    },
    setImgURL (state, id) {
      state.imgURL = id
    },
    setURL (state, id) {
      state.URL = id
    },
    setAuthenticated (state, id) {
      state.authenticated = id
    },
    setResult (state, id) {
      state.result = id
    },
    setSearchText (state, txt){
      state.searchText = txt
    },
    setTotalRes (state, id){
      state.totalRes = id
    },
    setSearchPack (state, id){
      state.searchPack = id
    },
    setResults (state, payload){
      state.results = payload
    },
    setMapping (state, payload){
      state.mapping = payload
    },
    setDiscussionMapping (state, payload){
      state.discussionMapping = payload
    },
    setDisableSearch (state, payload){
      state.disableSearch = payload
    },
    setPrevVisited(state, payload){
      state.prevVisited = payload
    },
    setShowMenu(state, payload){
      state.showMenu = payload
    }
  },
  getters:{
    getImageValidDic: (state) => {
      return state.imageValidDic
    },
    caveEntries: (state) => {
      return state.caveEntries
    },
    getLoadedPDFs: (state) => {
      return state.loadedPDFs
    },
    getStatistics: (state) => {
      return state.statistics
    },
    getBreadcrumb: (state) => {
      return state.breadcrumb
    },
    getGameLoaded: (state) => {
      return state.gameLoaded
    },
    getUser: (state) => {
      return state.user
    },
    appVersion: (state) => {
      return state.packageVersion
    },
    getWallLocation: state => {
      return state.wallLocation
    },
    getCaveTypes: state => {
      return state.caveTypes
    },
    getDistricts: state => {
      return state.districts
    },
    getRegions: state => {
      return state.regions
    },
    getSites: state => {
      return state.site
    },
    getStyles: state => {
      return state.styles
    },
    getBibKeyWords: state => {
      return state.bibKeywords
    },
    getLocations: state => {
      return state.locations
    },
    getURL : state => {
      return state.URL
    },
    getImgURL : state => {
      return state.imgURL
    },
    getAuthenticated : state => {
      return state.authenticated
    },
    getSearchText : state => {
      return state.searchText
    },
    getTotalRes : state => {
      return state.totalRes
    },
    getsearchPack : state => {
      return state.searchPack
    },
    getResult : state => {
      return state.result
    },
    getResults : state => {
      return state.results
    },
    getMapping : state => {
      return state.mapping
    },
    getDiscussionMapping : state => {
      return state.discussionMapping
    },
    getDisableSearch : state => {
      return state.disableSearch
    },
    getPrevVisited : state => {
      return state.prevVisited
    },
    getShowMenu : state => {
      return state.showMenu
    }
  },
  actions: {
    resetImageValidDic(context){
      context.state.imageValidDic = {}
    },
    fetchCaveEntries({ commit }) {
      getCaveEntries()
        .then(res=> {
          const caveEntries = res.data.hits.hits.map(hit => ({
            caveID: hit._source.caveID,
            caveEntryName: hit.fields.caveEntryName[0]  // Anpassen je nach Antwortstruktur
          }));
          commit('setCaveEntries', caveEntries);
        }).catch(function (error) {
          console.log(error)
          return null
        })
    },
    buildImageValidDic(context, images){
      async function fetchWithAuthentication(image, sessionId) {

        const headers = new Headers();
        if (sessionId && sessionId !== "") headers.set('Authorization',`Bearer ${sessionId}`  );
        var res = null
        if (image.imageID){
          res = await fetch(process.env.VUE_APP_IIIFAPI + "/iiif/2/kucha%2Fimages%2F" + image.filename + "/full/!80,80/0/default.jpg", { headers })
        } else if (image.caveID){
          res = await fetch(process.env.VUE_APP_IIIFAPI + "/iiif/2/kucha%2Fcavesketches%2F" + image.caveSketchID + "." + image.imageType + "/full/!80,80/0/default.jpg", { headers })
        }
        const binaryData = await res.arrayBuffer();
        context.commit('addThumbnail', {"index":image.imageID ? image.imageID : ("cave-" + image.caveSketchID), "thumbnail": "data:image/jpg;base64," + btoa(String.fromCharCode(...new Uint8Array(binaryData)))});
      }
      for (const image of images){
        if (!Object.hasOwn(context.getters.getImageValidDic, image.imageID ? image.imageID : ("cave-" + image.caveSketchID))){
          if (image.caveSketchID){
            fetchWithAuthentication(image, context.state.user.sessionID ? context.state.user.sessionID : "" )
            context.commit('addToimageValidDic', {"index":"cave-" + image.caveSketchID, "valid":true})
          } else if (image.accessLevel){
            if (image.accessLevel === 2){
              if (image.isExpiring){
                if (image.expiresAt <= Date.now()){
                  context.commit('addToimageValidDic', {"index":image.imageID, "valid":false})
                } else {
                  context.commit('addToimageValidDic', {"index":image.imageID, "valid":true})
                }
              } else {
                context.commit('addToimageValidDic', {"index":image.imageID, "valid":true})
              }
              fetchWithAuthentication(image, context.state.user.sessionID ? context.state.user.sessionID : "" )
            } else {
              context.commit('addToimageValidDic', {"index":image.imageID, "valid":false})
              fetchWithAuthentication(image, context.state.user.sessionID ? context.state.user.sessionID : "" )
              if (context.state.user.sessionID){
                isValidImage(image, context.state.user.sessionID).then(res => {
                  if (res.status === 200){
                    context.commit('addToimageValidDic', {"index":image.imageID, "valid":true})
                    fetchWithAuthentication(image, context.state.user.sessionID ? context.state.user.sessionID : "" )
                  }
                }).catch(function (error) {
                  console.log(error);
                })
              }
            }
          } else {

            context.commit('addToimageValidDic', {"index":image.imageID, "valid":false})
            if (context.state.user.sessionID){
              isValidImage(image, this.user.sessionID).then(res => {
                if (res.status === 200){
                  context.commit('addToimageValidDic', {"index":image.imageID, "valid":true})
                  fetchWithAuthentication(image, context.state.user.sessionID ? context.state.user.sessionID : "" )
                }
              }).catch(function (error) {
                console.log(error);
              })
            }
          }
        }
      }
    },
    getWallLocation(context){
      getDictionary('wallTree')
        .then(res=> {
          context.commit('setWallLocation', res.data._source.wallTree);
        }).catch(function (error) {
          console.log(error)
          return null
        })
    },
    getLocations(context){
      getDictionary('locations')
        .then(res=> {
          context.commit('setLocations', res.data._source.locations);
        }).catch(function (error) {
          console.log(error)
          return null
        })
    },
    getCaveTypes(context){
      getDictionary('caveTypes')
        .then(res=> {
          context.commit('setCaveTypes', res.data._source.caveTypes);
        }).catch(function (error) {
          console.log(error)
          return null
        })
    },
    getDistricts(context){
      getDictionary('districts')
        .then(res=> {
          context.commit('setDistricts', res.data._source.districts);
        }).catch(function (error) {
          console.log(error)
          return null
        })
    },
    getRegions(context){
      getDictionary('regions')
        .then(res=> {
          context.commit('setRegions', res.data._source.regions);
        }).catch(function (error) {
          console.log(error)
          return null
        })
    },
    getSites(context){
      getDictionary('sites')
        .then(res=> {
          let sites = res.data._source.sites
          sites.push({
            siteID: 0,
            name: "unknown"
          })
          context.commit('setSites', sites);
        }).catch(function (error) {
          console.log(error)
          return null
        })
    },
    getStyles(context){
      getDictionary('styles')
        .then(res=> {
          context.commit('setStyles', res.data._source.styles);
        }).catch(function (error) {
          console.log("styles error", error)
          return null
        })
    },
    getBibKeyWords(context){
      getDictionary('bibKeywords')
        .then(res=> {
          context.commit('setBibKeywords', res.data._source.bibKeywords);
        }).catch(function (error) {
          console.log(error)
          return null
        })
    },
    getIconography(context){
      getDictionary('iconographyTree')
        .then(res=> {
          function setChecked(item) {
            item['checked'] = false
            for (let child of item.children){
              setChecked(child)
            }
          }
          let iconography = res.data._source.iconography
          for (let root of iconography){
            setChecked(root)
          }
          context.commit('setIconography', iconography);
        }).catch(function (error) {
          console.log(error)
          return null
        })
    },

    fetchMapping: (context) =>{
      getKuchaMapping()
        .then(res=> {
          console.log("mapping", (window.location.origin.includes("test") || window.location.origin.includes("localhost")|| window.location.origin.includes("172") ? res.data.kucha_deep.mappings.properties : res.data.kucha_deep.mappings.properties));
          context.commit('setMapping', (window.location.origin.includes("test") || window.location.origin.includes("localhost")|| window.location.origin.includes("172") ? res.data.kucha_deep.mappings.properties : res.data.kucha_deep.mappings.properties));
        }).catch(function (error) {
          console.log(error)
          return null
        })
    },
    getDiscussionMapping: (context) =>{
      getKuchaDiscussionMapping()
        .then(res=> {
          context.commit('setDiscussionMapping', res.data.kucha_discussion.mappings.properties);
        }).catch(function (error) {
          console.log(error)
          return null
        })
    }
  }



})
